import React from 'react';
import {
  CheckCircle, ChevronDown, ChevronUp, Phone, Mail, Download, ArrowRight,
  Zap, Droplets, Waves, Shield, Navigation, Filter, RotateCcw, Timer,
  Maximize2, Sparkles, Cpu, CalendarClock, Smartphone, Battery,
  BatteryCharging, ScanLine, Wind, Volume2, Home, PawPrint,
  ThermometerSun, Trash2, Wifi, Map, Layers,
} from 'lucide-react';

export const ICONS = {
  CheckCircle, ChevronDown, ChevronUp, Phone, Mail, Download, ArrowRight,
  Zap, Droplets, Waves, Shield, Navigation, Filter, RotateCcw, Timer,
  Maximize2, Sparkles, Cpu, CalendarClock, Smartphone, Battery,
  BatteryCharging, ScanLine, Wind, Volume2, Home, PawPrint,
  ThermometerSun, Trash2, Wifi, Map, Layers,
};

export const Icon = ({ name, className }) => {
  const C = ICONS[name];
  return C ? <C className={className} /> : null;
};

export const ACCENTS = {
  emerald: {
    label: 'text-emerald-600',
    labelDark: 'text-emerald-400',
    heroBadge: 'bg-emerald-500/20 text-emerald-400',
    heroTagline: 'text-emerald-400',
    heroIcon: 'text-emerald-400',
    heroPriceNote: 'text-emerald-300',
    ctaPrimary: 'bg-emerald-500 hover:bg-emerald-400',
    ctaOutline: 'border-emerald-500/50 hover:border-emerald-400 text-emerald-400',
    check: 'text-emerald-500',
    stat: 'text-emerald-600',
    iconBox: 'bg-emerald-100',
    icon: 'text-emerald-600',
    featureIconBox: 'bg-emerald-100 group-hover:bg-emerald-500',
    featureIcon: 'text-emerald-600 group-hover:text-white',
    darkIcon: 'text-emerald-400',
    darkBadge: 'bg-emerald-500/20',
    darkBadgeText: 'text-emerald-400',
    darkCheck: 'text-emerald-400',
    specActive: 'bg-emerald-500',
    specValue: 'text-emerald-400',
    chevron: 'text-emerald-600',
    link: 'text-emerald-600 hover:text-emerald-700',
    contactText: 'text-emerald-100',
    contactSub: 'text-emerald-200',
    contactBtn: 'text-emerald-700 hover:bg-emerald-100',
    groupPanel: 'from-emerald-50 to-gray-50',
    tag: 'bg-emerald-50 text-emerald-700',
  },
  blue: {
    label: 'text-blue-600',
    labelDark: 'text-blue-400',
    heroBadge: 'bg-blue-500/20 text-blue-300',
    heroTagline: 'text-blue-300',
    heroIcon: 'text-blue-300',
    heroPriceNote: 'text-blue-300',
    ctaPrimary: 'bg-blue-500 hover:bg-blue-400',
    ctaOutline: 'border-blue-500/50 hover:border-blue-400 text-blue-300',
    check: 'text-blue-500',
    stat: 'text-blue-600',
    iconBox: 'bg-blue-100',
    icon: 'text-blue-600',
    featureIconBox: 'bg-blue-100 group-hover:bg-blue-500',
    featureIcon: 'text-blue-600 group-hover:text-white',
    darkIcon: 'text-blue-400',
    darkBadge: 'bg-blue-500/20',
    darkBadgeText: 'text-blue-300',
    darkCheck: 'text-blue-400',
    specActive: 'bg-blue-500',
    specValue: 'text-blue-400',
    chevron: 'text-blue-600',
    link: 'text-blue-600 hover:text-blue-700',
    contactText: 'text-blue-100',
    contactSub: 'text-blue-200',
    contactBtn: 'text-blue-700 hover:bg-blue-100',
    groupPanel: 'from-blue-50 to-gray-50',
    tag: 'bg-blue-50 text-blue-700',
  },
  cyan: {
    label: 'text-cyan-600',
    labelDark: 'text-cyan-400',
    heroBadge: 'bg-cyan-500/20 text-cyan-300',
    heroTagline: 'text-cyan-300',
    heroIcon: 'text-cyan-300',
    heroPriceNote: 'text-cyan-300',
    ctaPrimary: 'bg-cyan-500 hover:bg-cyan-400',
    ctaOutline: 'border-cyan-500/50 hover:border-cyan-400 text-cyan-300',
    check: 'text-cyan-500',
    stat: 'text-cyan-600',
    iconBox: 'bg-cyan-100',
    icon: 'text-cyan-600',
    featureIconBox: 'bg-cyan-100 group-hover:bg-cyan-500',
    featureIcon: 'text-cyan-600 group-hover:text-white',
    darkIcon: 'text-cyan-400',
    darkBadge: 'bg-cyan-500/20',
    darkBadgeText: 'text-cyan-300',
    darkCheck: 'text-cyan-400',
    specActive: 'bg-cyan-500',
    specValue: 'text-cyan-400',
    chevron: 'text-cyan-600',
    link: 'text-cyan-600 hover:text-cyan-700',
    contactText: 'text-cyan-100',
    contactSub: 'text-cyan-200',
    contactBtn: 'text-cyan-700 hover:bg-cyan-100',
    groupPanel: 'from-cyan-50 to-gray-50',
    tag: 'bg-cyan-50 text-cyan-700',
  },
};

export const sectionBg = (bg) => `py-20 px-6 lg:px-12${bg === 'gray' ? ' bg-gray-50' : ''}`;
